export default __webpack_public_path__ + "static/media/choose.daaa5987.svg";